import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import flutter from "../assets/flutter.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import react from "../assets/react.png";
import sass from "../assets/sass.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  email,
  mobile,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  node,
  python,
  react,
  sass,
  about01,
  about02,
  about03,
  about04,
  circle,
  logo,
};
